// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo-logoColor-am5Gl {
	color: var(--primary-bg);
}

.Logo-whiteColor-zLPH3 {
	color: var(--common-primary-white-foreground);
}

.Logo-logoTextTabViewWidth-QVx6E {
	text-overflow: ellipsis;
	overflow: hidden;
	display: block;
	width: 100%;
	max-width: 180px;
	white-space: nowrap;
}

@media screen and (max-width:1299px) {
	.Logo-logoTextTabViewWidth-QVx6E {
		max-width: 145px;
	}
}

@media screen and (max-width: 1199px) {
	.Logo-logoTextTabViewWidth-QVx6E {
		max-width: 180px;
	}
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.Logo-logoTextTabViewWidth-QVx6E {
		max-width: 110px;
	}
}

@media screen and (max-width: 767px) {
	.Logo-logoTextTabViewWidth-QVx6E {
		max-width: 200px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Logo/Logo.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;AACzB;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".logoColor {\n\tcolor: var(--primary-bg);\n}\n\n.whiteColor {\n\tcolor: var(--common-primary-white-foreground);\n}\n\n.logoTextTabViewWidth {\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tdisplay: block;\n\twidth: 100%;\n\tmax-width: 180px;\n\twhite-space: nowrap;\n}\n\n@media screen and (max-width:1299px) {\n\t.logoTextTabViewWidth {\n\t\tmax-width: 145px;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.logoTextTabViewWidth {\n\t\tmax-width: 180px;\n\t}\n}\n\n@media screen and (min-width: 768px) and (max-width: 991px) {\n\t.logoTextTabViewWidth {\n\t\tmax-width: 110px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.logoTextTabViewWidth {\n\t\tmax-width: 200px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoColor": `Logo-logoColor-am5Gl`,
	"whiteColor": `Logo-whiteColor-zLPH3`,
	"logoTextTabViewWidth": `Logo-logoTextTabViewWidth-QVx6E`
};
module.exports = ___CSS_LOADER_EXPORT___;
